import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useContactCompanies() {
  const api = useAxios();

  const { data } = useQuery({
    queryKey: ["contact-companies"],
    queryFn: () => api.get("/contacts/companies"),
    staleTime: 5 * 60 * 1000,
    throwOnError: false,
  });

  return { companies: data?.data ?? [] };
}
